export const ActionType = {
  JOB_REQUEST_FORM_DATA_START: 'JOB_REQUEST_FORM_DATA_START',
  JOB_REQUEST_FORM_DATA_COMPLETED: 'JOB_REQUEST_FORM_DATA_COMPLETED',
  GET_JOB_REQUEST_FORM_DATA: 'GET_JOB_REQUEST_FORM_DATA',

  JOB_INTEREST_DETAILS_FETCH_STARTED: 'JOB_INTEREST_DETAILS_FETCH_STARTED',
  JOB_INTEREST_DETAILS_FETCH_COMPLETED: 'JOB_INTEREST_DETAILS_FETCH_COMPLETED',
  GET_JOB_INTEREST_DETAILS: 'GET_JOB_INTEREST_DETAILS',

  GET_JOB_INFO: 'GET_JOB_INFO',
  JOB_INTEREST_REQUEST: 'JOB_INTEREST_REQUEST',
  JOB_INTEREST_COMPLETED: 'JOB_INTEREST_COMPLETED',
  UPDATE_JOB_INTEREST_DETAILS: 'UPDATE_JOB_INTEREST_DETAILS',
  GET_DEVELOPER_INFO: 'GET_DEVELOPER_INFO',

  NOT_INTERESTED_REASONS_FETCH_STARTED: 'NOT_INTERESTED_REASONS_FETCH_STARTED',
  NOT_INTERESTED_REASONS_FETCH_COMPLETED: 'NOT_INTERESTED_REASONS_FETCH_COMPLETED',
  GET_NOT_INTERESTED_REASONS: 'GET_NOT_INTERESTED_REASONS',

  GET_DEVELOPER_AVAILABILITY_FROM_HASH: 'GET_DEVELOPER_AVAILABILITY_HASH',
  UPDATE_DEVELOPER_AVAILABILITY_STATUS_FROM_JOB_INTEREST_FORM:
    'UPDATE_DEVELOPER_AVAILABILITY_STATUS_FROM_JOB_INTEREST_FORM',
  GET_DEVELOPER_RATE_DETAILS_FROM_JOB_INTEREST_FORM:
    'GET_DEVELOPER_RATE_DETAILS_FROM_JOB_INTEREST_FORM',
};
